<ng-container
  *ngVar="{
    canDownloadEvidence: (canDownloadEvidence$ | async),
    hasPendingAccess: (hasPendingAccess$ | async),
  } as data"
>
  <div *ngVar="loading$ | async as loading" class="flex flex-col gap-4 items-center justify-center w-full">
    <div
      class="w-full px-2.5 py-3 rounded-md border border-navy-50 bg-white flex justify-between group"
      [ngClass]="{ 'cursor-pointer hover:border-navy-90': data.hasPendingAccess === false }"
    >
      <div class="flex gap-2 items-center max-w-full flex-1 overflow-hidden">
        <svg-icon class="w-7.5 h-7.5 text-navy-90" [src]="'evidence-dark'"></svg-icon>
        <div class="text-navy-90 text-base font-secondary">{{ evidence.trustcenter_display_name }}</div>
      </div>

      @if (data.canDownloadEvidence) {
        <ng-container *ngTemplateOutlet="downloadBtn"></ng-container>
      } @else if (data.canDownloadEvidence === false) {
        @if (data.hasPendingAccess) {
          <ng-container *ngTemplateOutlet="pendingAccessBtn"></ng-container>
        } @else if (data.hasPendingAccess === false) {
          <ng-container *ngTemplateOutlet="requestAccessBtn"></ng-container>
        }
      }
    </div>

    @if (data.canDownloadEvidence) {
      <ng-container *ngTemplateOutlet="downloadBtn; context: { isMobile: true }"></ng-container>
    } @else if (data.canDownloadEvidence === false) {
      @if (data.hasPendingAccess) {
        <ng-container *ngTemplateOutlet="pendingAccessBtn; context: { isMobile: true }"></ng-container>
      } @else if (data.hasPendingAccess === false) {
        <ng-container *ngTemplateOutlet="requestAccessBtn; context: { isMobile: true }"></ng-container>
      }
    }
  </div>
</ng-container>

<ng-template #requestAccessBtn let-isMobile="isMobile">
  <app-new-button
    class="request-access-btn {{ isMobile ? 'w-full flex md:hidden' : 'hidden md:flex' }}"
    [svgIconPath]="'lock'"
    [size]="'responsive'"
    [type]="'basic'"
    [loading]="loading$ | async"
    [saveButtonSizeDuringLoading]="true"
    (click)="requestAccess()"
  >
    {{ buildTranslationKey('requestAccess') | translate }}
  </app-new-button>
</ng-template>

<ng-template #pendingAccessBtn let-isMobile="isMobile">
  <app-new-button
    class="pending-access-btn {{ isMobile ? 'flex md:hidden' : 'hidden md:flex' }}"
    [size]="'responsive'"
    [type]="'basic'"
    [svgIconPath]="'lock'"
  >
    {{ buildTranslationKey('pendingAccess') | translate }}
  </app-new-button>
</ng-template>

<ng-template #downloadBtn let-isMobile="isMobile">
  <app-new-button
    class="download-btn {{ isMobile ? 'w-full flex md:hidden' : 'hidden md:flex' }}"
    [svgIconPath]="isUrlEvidence ? 'newscreen' : 'download'"
    [size]="'responsive'"
    [type]="'basic'"
    [loading]="loading$ | async"
    [saveButtonSizeDuringLoading]="true"
    [disabled]="isUrlEvidence ? !evidence.evidence_url : false"
    (click)="isUrlEvidence ? openLinkEvidence(evidence.evidence_url) : downloadEvidence(evidence)"
  >
    {{ buildTranslationKey(isUrlEvidence ? 'openInTab' : 'download') | translate }}
  </app-new-button>
</ng-template>
